import { useEffect, useState } from "react";
import { builder } from "@builder.io/react";
import type { BuilderContent } from "@builder.io/sdk";

import { sectionModel } from "@/builder/model-names";

export type BuilderComponents = {
  marbleBenefits?: BuilderContent;
  reviews?: BuilderContent;
};

export function useConfirmationPageBuilderComponents() {
  const [builderComponents, setBuilderComponents] =
    useState<BuilderComponents | null>(null);

  useEffect(() => {
    async function fetchBuilderComponents() {
      const components: BuilderComponents = {};

      const marbleBenefits = await builder.get(sectionModel.symbol, {
        entry: "34d1039b11674799aa675778ee4c80b2",
      });

      const reviews = await builder.get(sectionModel.symbol, {
        entry: "87e4b9ba1ea74d73abbf659241ceccf3",
      });

      if (marbleBenefits) {
        components.marbleBenefits = marbleBenefits;
      }

      if (reviews) {
        components.reviews = reviews;
      }

      setBuilderComponents(components);
    }

    fetchBuilderComponents();
  }, []);

  return { builderComponents, setBuilderComponents };
}
